import React from "react";
import {cn} from "../../../utils/general";

const Button = ({ children = "Push Me", className = "", variant = "primary", ...buttonProps }) => {
  const variants = {
    primary: {
      background: "linear-gradient(360deg, black 0%, #525252 25%)",
      surface: "radial-gradient(80% 25% at 50% 100%, rgb(100 100 100) 0%, rgb(0, 0, 0) 64.95%)",
      border: "border-neutral-600"
    },
    secondary: {
      background: "linear-gradient(360deg, #8B0000 0%, #DC143C 25%)",
      surface: "radial-gradient(80% 25% at 50% 100%, rgb(255 100 100) 0%, rgb(139, 0, 0) 64.95%)",
      border: "border-red-700"
    }
  };

  const currentVariant = variants[variant] || variants.black;

  return (
    <button
      {...buttonProps}
      className="group relative text-center select-none focus:outline-offset-4 transition-[filter] duration-[100ms] hover:brightness-110"
    >
      {/* sombra inferior semitransparente */}
      <span
        className="absolute inset-0 w-full h-full bg-black/10 rounded-[16px] translate-y-[3px] transition-all duration-[100ms] ease-[cubic-bezier(0.3,0.7,0.4,1)] 
        group-hover:translate-y-[4px] group-focus-visible:translate-y-[4px] group-active:translate-y-[1px]"
      ></span>

      {/* capa de fondo lateral con degradado negro */}
      <span
        className="absolute [box-shadow:0_4px_10px_0_#000] group-active:[box-shadow:0_4px_6px_0_#000] transition-all duration-[100ms] inset-0 w-full h-full rounded-[16px]"
        style={{ background: currentVariant.background }}
      ></span>

      {/* botón superior negro brillante */}
      <span
        className={cn(`relative flex items-center justify-center px-[42px] border-b-2 ${currentVariant.border} py-[12px] text-white font-bold text-[20px] rounded-[16px] transform -translate-y-[8px] 
        transition-all duration-[100ms] ease-[cubic-bezier(0.3,0.7,0.4,1)] hover:-translate-y-[7px] group-active:border-b-0 group-active:-translate-y-[1px]`,className)}
        style={{
          background: currentVariant.surface
        }}
      >
        <span className="absolute left-[50%] w-[90%] h-3 blur-sm bg-white/20 rounded-full top-1 translate-x-[-50%]"></span>
        {children}
      </span>
    </button>
  );
};

export default Button;
